import { useState } from "react"
import ContractInterface from "../../interfaces/Contract.interface"
import Modal from "../Modal"
import { Link } from "react-router-dom"

const contractStatus: Record<string, string> = {
    "Pending": "Pendiente",
    "Active": "Activo",
    "Inactive": "Inactivo",
    "Rejected": "Rechazado",
    "Terminated": "Terminado"
}

const TeamContract: React.FC<{ contract: ContractInterface }> = ({ contract }) => {
    const [showDetails, setShowDetails] = useState(false)
    return (
        <>
            <Modal modalOpen={showDetails} set={setShowDetails}>
                <div className="w-[420px] flex flex-col gap-5 bg-white p-5 rounded">
                    <p className="text-zinc-700 text-xl">Detalles</p>

                    <div className="flex gap-5 items-center">
                        <div className="flex flex-col overflow-hidden">
                            <Link to={`/p/${contract.team_member?.player?.name}`} className="text-lg text-zinc-700 font-bold hover:underline">{contract.team_member?.player?.name}</Link>

                        </div>
                    </div>

                    <div className="flex flex-col gap-2">
                        <p className="text-sm uppercase text-zinc-700">Fecha de inicio</p>
                        <p className="text-zinc-500">{new Date(contract.start_date as string).toLocaleDateString()}</p>
                    </div>

                    <div className="flex flex-col gap-2">
                        <p className="text-sm uppercase text-zinc-700">Fecha de finalización</p>
                        <p className="text-zinc-500">{new Date(contract.end_date as string).toLocaleDateString()}</p>
                    </div>

                    <div className="flex flex-col gap-2">
                        <p className="text-sm uppercase text-zinc-700">Valor</p>
                        <p className="text-zinc-500">${contract.value}</p>
                        <p className="text-zinc-700 text-xs">* Este valor se recibirá cuando finalice el contrato.</p>
                    </div>

                    <div className="flex flex-col gap-2">
                        <p className="text-sm uppercase text-zinc-700">Condiciones</p>
                        <p className="text-zinc-500">{contract?.conditions && contract?.conditions?.length > 0 ? contract.conditions : "-"}</p>
                        <p className="text-zinc-700 text-xs">* Las condiciones pueden corresponder a una ganancia mayor en base al desempeño.</p>
                    </div>

                    <div className="flex flex-col gap-2">
                        <p className="text-sm uppercase text-zinc-700">Estado</p>
                        <p className="text-zinc-500">{contractStatus[contract.status as string]}</p>
                    </div>
                </div>
            </Modal>
            <div className="flex flex-col gap-2 border p-5 rounded cursor-pointer" onClick={() => setShowDetails(true)}>
                <div className="flex gap-5">
                    <div className="flex flex-col">
                        <p className="text-lg text-zinc-700 font-bold">{contract.team_member?.player?.name}</p>
                        <p className="text-sm text-zinc-500">${contract.value}</p>
                        <p className="text-sm text-yellow-500 font-bold">{contractStatus[contract?.status as string]}</p>
                    </div>
                </div>
            </div>
        </>
    )
}

export default TeamContract